export default class CrashOnPurposeService {
    static crashOnPurpose() {
        console.warn(`Throwing an error on purpose...`);
        this.throwErrorOnPurpose();
    }
}